<app-modal [title]="modalTitle()" [opened]="isOpen()" size="lg"
    [loading]="!isDropdownDataReady()"
    [loadError]="dropdownCache.hasAnyError()"
    (closeTrigger)="handleModalClose()">
    <div class="modal-content-wrapper">
        <div class="modal-scrollable-content">
            <form [formGroup]="createForm" (ngSubmit)="submit()" class="modal-form">

                <!-- Customer Type Display -->
                <div class="customer-type-badge" [class]="customerType()">
                    <span class="type-label">{{ dictionaryService.get('CustomerType') || 'Customer Type' }}</span>
                    <span class="type-value">{{ dictionaryService.get(customerType()) || customerType() }}</span>
                </div>

                <div class="form-grid">
                    <!-- Name Input -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Name') || 'Name' }} *</span>
                        <app-input type="text" formControlName="name"
                            [placeholder]="dictionaryService.get('EnterName') || 'Enter name'" size="md"
                            name="name" [isError]="isNameInvalid()"></app-input>
                        @if (isNameInvalid()) {
                        <span class="field-error">{{ dictionaryService.get('Required') || 'This field is required.' }}</span>
                        }
                    </div>

                    <!-- Email Input -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Email') || 'Email' }}</span>
                        <app-input type="text" formControlName="email"
                            [placeholder]="dictionaryService.get('EnterEmail') || 'Enter email'" size="md"
                            name="email" [isError]="isEmailInvalid()"></app-input>
                        @if (isEmailInvalid()) {
                        <span class="field-error">{{ dictionaryService.get('InvalidEmailWithExample') || 'Please enter a valid email address. Example: name@example.com' }}</span>
                        }
                    </div>

                    <!-- Phone Input -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Phone') || 'Phone' }}</span>
                        <app-input type="text" formControlName="phone"
                            [placeholder]="dictionaryService.get('EnterPhone') || 'Enter phone'" size="md"
                            name="phone"></app-input>
                    </div>

                    <!-- Country Select -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Country') || 'Country' }} *</span>
                        <app-select [options]="dropdownCache.countryOptions()" [placeholder]="dictionaryService.get('SelectCountry') || 'Select country'" [isFullWidth]="true" [disableSearch]="true" [defaultOption]="selectedCountry()" [class]="isRequiredSelectInvalid(selectedCountry(), 'country') ? 'error-outline' : ''" (getSelectedOption)="onCountryChange($event)" (focusout)="markSelectTouched('country', $event)"></app-select>
                        @if (isRequiredSelectInvalid(selectedCountry(), 'country')) {
                        <span class="field-error">{{ dictionaryService.get('Required') || 'This field is required.' }}</span>
                        }
                    </div>

                    <!-- Province Select -->
                    <div class="input-group" [class.disabled]="isProvinceDisabled()">
                        <span class="input-label">{{ dictionaryService.get('Province') || 'Province' }} *</span>
                        <app-select [options]="dropdownCache.provinceOptions()" [placeholder]="dictionaryService.get('SelectProvince') || 'Select province'" [isFullWidth]="true" [disableSearch]="false" [defaultOption]="selectedProvince()" [class]="isRequiredSelectInvalid(selectedProvince(), 'province') ? 'error-outline' : ''" (getSelectedOption)="onProvinceChange($event)" (focusout)="markSelectTouched('province', $event)"></app-select>
                        @if (isRequiredSelectInvalid(selectedProvince(), 'province')) {
                        <span class="field-error">{{ dictionaryService.get('Required') || 'This field is required.' }}</span>
                        }
                    </div>

                    <!-- City Select -->
                    <div class="input-group" [class.disabled]="isCityDisabled()">
                        <span class="input-label">{{ dictionaryService.get('City') || 'City' }} *</span>
                        <app-select [options]="cityOptions()" [placeholder]="dictionaryService.get('SelectCity') || 'Select city'" [isFullWidth]="true" [disableSearch]="false" [defaultOption]="selectedCity()" [class]="isRequiredSelectInvalid(selectedCity(), 'city') ? 'error-outline' : ''" (getSelectedOption)="onCityChange($event)" (focusout)="markSelectTouched('city', $event)"></app-select>
                        @if (isRequiredSelectInvalid(selectedCity(), 'city')) {
                        <span class="field-error">{{ dictionaryService.get('Required') || 'This field is required.' }}</span>
                        }
                    </div>
                    <!-- Doctor-specific: Speciality -->
                    @if (showField('speciality')) {
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Speciality') || 'Speciality' }} *</span>
                        <app-select [options]="dropdownCache.specialityOptions()" [placeholder]="dictionaryService.get('SelectSpeciality') || 'Select speciality'" [isFullWidth]="true" [disableSearch]="false" [defaultOption]="selectedSpeciality()" [class]="isRequiredSelectInvalid(selectedSpeciality(), 'speciality') ? 'error-outline' : ''" (getSelectedOption)="onSpecialityChange($event)" (focusout)="markSelectTouched('speciality', $event)"></app-select>
                        @if (isRequiredSelectInvalid(selectedSpeciality(), 'speciality')) {
                        <span class="field-error">{{ dictionaryService.get('Required') || 'This field is required.' }}</span>
                        }
                    </div>
                    }

                    <!-- Doctor-specific: Center -->
                    @if (showField('center')) {
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Center') || 'Center' }} *</span>
                        <app-input type="text" formControlName="center"
                            [placeholder]="dictionaryService.get('EnterCenter') || 'Enter center'" size="md"
                            name="center" [isError]="isCenterInvalid()"></app-input>
                        @if (isCenterInvalid()) {
                        <span class="field-error">{{ dictionaryService.get('Required') || 'This field is required.' }}</span>
                        }
                    </div>
                    }

                    <!-- Hospital-specific: Doctors Section -->
                    @if (showField('hospitalDoctors')) {
                    <div class="input-group full-width doctors-section">
                        <span class="input-label">{{ dictionaryService.get('Doctors') || 'Doctors' }}
                            <small>{{ dictionaryService.get('AtLeastOneItem') || 'at least one item' }}</small> *</span>

                        <div class="doctors-list">
                            @for (doctor of hospitalDoctors(); track $index) {
                            <div class="doctor-entry">
                                <div class="doctor-fields">
                                    <div class="input-group">
                                        <span class="input-label">{{ dictionaryService.get('Name') || 'Name' }} *</span>
                                        <app-input type="text" [initialValue]="doctor.name"
                                            [placeholder]="dictionaryService.get('EnterDoctorName') || 'Enter doctor name'"
                                            size="md" [name]="'doctorName' + $index"
                                            [isError]="isHospitalDoctorNameInvalid($index)"
                                            (onChange)="updateHospitalDoctorName($index, $event)"></app-input>
                                        @if (isHospitalDoctorNameInvalid($index)) {
                                        <span class="field-error">{{ dictionaryService.get('Required') || 'This field is required.' }}</span>
                                        }
                                    </div>
                                    <div class="input-group">
                                        <span class="input-label">{{ dictionaryService.get('Speciality') || 'Speciality'
                                            }} *</span>
                                        <app-select [options]="dropdownCache.specialityOptions()"
                                            [placeholder]="dictionaryService.get('SelectSpeciality') || 'Select speciality'"
                                            [isFullWidth]="true" [disableSearch]="false" [defaultOption]="doctor.speciality"
                                            [class]="isHospitalDoctorSpecialityInvalid($index) ? 'error-outline' : ''"
                                            (focusout)="markSelectTouched('hospitalDoctorSpeciality-' + $index, $event)"
                                            (getSelectedOption)="updateHospitalDoctorSpeciality($index, $event.value)"></app-select>
                                        @if (isHospitalDoctorSpecialityInvalid($index)) {
                                        <span class="field-error">{{ dictionaryService.get('Required') || 'This field is required.' }}</span>
                                        }
                                    </div>
                                </div>
                                @if (hospitalDoctors().length > 1) {
                                <button type="button" class="remove-doctor-btn" (click)="removeHospitalDoctor($index)">
                                    {{ dictionaryService.get('Remove') || 'remove' }}
                                </button>
                                }
                            </div>
                            }
                        </div>

                        <button type="button" class="add-doctor-btn" (click)="addHospitalDoctor()">
                            <span class="add-icon">+</span>
                        </button>
                    </div>
                    }

                    <!-- Classification Section Header -->
                    <div class="section-divider full-width">
                        <span class="section-title">{{ dictionaryService.get('Classification') || 'Classification'
                            }}</span>
                    </div>
                </div>

                <!-- Classification fields - dropdowns open upward to avoid clipping -->
                <div class="form-grid classification-fields">
                    <!-- Class Type Select -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('ClassType') }} *</span>
                        <app-select [options]="dropdownCache.classOptions()" [placeholder]="dictionaryService.get('SelectClassType')" [isFullWidth]="true" [disableSearch]="true" [defaultOption]="selectedClassType()" [class]="isRequiredSelectInvalid(selectedClassType(), 'classType') ? 'error-outline' : ''" (getSelectedOption)="onClassTypeChange($event)" (focusout)="markSelectTouched('classType', $event)"></app-select>
                        @if (isRequiredSelectInvalid(selectedClassType(), 'classType')) {
                        <span class="field-error">{{ dictionaryService.get('Required') || 'This field is required.' }}</span>
                        }
                    </div>

                    <!-- Market Class Select -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('MktClass') }}</span>
                        <app-select [options]="dropdownCache.classOptions()" [placeholder]="dictionaryService.get('SelectMktClass')" [isFullWidth]="true" [disableSearch]="true" [defaultOption]="selectedMktClass()" (getSelectedOption)="onMktClassChange($event)"></app-select>
                    </div>

                    <!-- Special Class Select -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('SpecialClass') }}</span>
                        <app-select [options]="dropdownCache.classOptions()" [placeholder]="dictionaryService.get('SelectSpecialClass')" [isFullWidth]="true" [disableSearch]="true" [defaultOption]="selectedSpecialClass()" (getSelectedOption)="onSpecialClassChange($event)"></app-select>
                    </div>

                    <!-- Targeted Frequency Input -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('TargetedFrequency') }} *</span>
                        <app-input type="number" formControlName="targetedFrequency"
                            [placeholder]="dictionaryService.get('EnterTargetedFrequency')" size="md"
                            name="targetedFrequency" [isError]="isTargetedFrequencyInvalid()"></app-input>
                        @if (isTargetedFrequencyInvalid()) {
                        <span class="field-error">{{ getTargetedFrequencyErrorMessage() }}</span>
                        }
                    </div>
                </div>
            </form>
        </div>

        <!-- Footer Buttons - Fixed at bottom -->
        <div class="modal-footer">
            <button buttonTheme="light" buttonType="regular" size="rg" (click)="handleModalClose()" class="cancel-btn">
                {{ dictionaryService.get('Cancel') }}
            </button>
            <button buttonTheme="primary" buttonType="regular" size="rg" (click)="submit()" [disabled]="!isFormValid()">
                {{ dictionaryService.get('Add') }}
            </button>
        </div>
    </div>
</app-modal>
